import React, {useState} from 'react';
import { statementSubmitRequest } from '../../remote/usersRequests';
import {TextField, Typography } from "@mui/material"
import PurpleButton from '../LayoutComponents/PurpleButton'


const SubmitStatement = ({session, setSkills, setNewlyAddedSkills, showToast }) => {
    const [statement, setStatement] = useState("");

    const submitStatement = async () => {
        try {
            if (!statement.trim()) {
                showToast?.('Please enter a statement before submitting.', 'warning');  
                return;     
            }
            const response = await statementSubmitRequest(session.token, statement, session.userId);
            if (response.status === 200 && response.data) {
                setStatement("");
                const newSkills = response.data || [];
                setSkills(prev => [...newSkills , ...prev]);
                setNewlyAddedSkills(newSkills.map(s => s.compXwalkId));
                
                showToast?.(`Matched ${response.data.length} competencies! New skills highlighted in green.`, 'success');
            }
        } catch (error) {
            console.error('Error submitting statement:', error);
            showToast?.('Failed to submit statement. Please try again.', 'error');
        }
    };


    return (
        <>
            <Typography variant="h6">
            
            </Typography>
            <TextField
                placeholder="Use this space to submit a statement about your skills, experiences, and qualifications. Our system will analyze your input to identify relevant competencies that match your profile."
                variant="outlined"
                fullWidth   
                value={statement}
                onChange={(e) => setStatement(e.target.value)}
                multiline
                minRows={5}
                maxRows={50}
                sx={{ mb: 2 }}
            />
            <PurpleButton type='submit' onClick={submitStatement} label='Submit Statement'/>
        </>
    )
}

export default SubmitStatement
